module.exports = __webpack_public_path__ + "img/ban3.e0d04095.jpg";